<template>
    <div class="webim-bg-select section-item-line">
        <div class="section-item-label">
            {{ titleText }}
        </div>
        <div class="section-item-content">
            <div class="webim-bg-select__btn">
                <span
                    :style="`background-image:url(${imageUrl})`"
                    @click="handleEdit"
                    :class="imageUrl? 'no-border' : ''"
                    class="webim-bg-select__preview"
                >
                    <span
                        v-if="!isEdit"
                        class="empty-text"
                    >请选择</span>
                </span>
                <span
                    v-if="isEdit"
                    @click="handleEdit"
                    class="webim-bg-select__btnStyle"
                >{{ btnText }}</span>
                <a
                    v-if="isEdit"
                    @click="handleDelete"
                    href="javascript:;"
                    class="webim-bg-select__delete"
                >
                    <span>删除</span>
                </a>
            </div>

            <img-select-panel
                :show="isShowImgSelectPanel"
                @handler-ok="handleImgSelectConfirm"
                @handler-cancel="isShowImgSelectPanel = false"
            />

            <img-cropper-panel
                :key="timer"
                :panel-open="isShowImgCropperPanel"
                :panel-width="630"
                :panel-height="570"
                :width="630"
                :height="408"
                :src="cropperUrl"
                :ratio="ratio"
                :keep-ratio="true"
                :cropper-scale="scale"
                @confirm="handleImgCropperConfirm"
                @cancel="handleImgCropperCancel"
                panel-title="选择展示范围"
            />
        </div>
    </div>
</template>

<script>
import ImgSelectPanel from '@/components/img-select-panel/index';
import ImgCropperPanel from '@/components/img-cropper-panel/index';

export default {
    components: {
        ImgSelectPanel,
        ImgCropperPanel,
    },

    props: {
        titleText: {
            type: String,
            default: '自定义背景',
        },
        platform: {
            type: String,
            default: '',
        },
        scale: {
            type: Number,
            default: 1,
        },
        initData: {
            type: Object,
            default: () => {},
        },
    },

    data() {
        let ratio = 0.75 / 1;

        if (this.platform === 'pc') {
            ratio = 520 / 418;
        } else if (this.platform === 'mobile') {
            ratio = 1 / 1;
        }

        return {
            isShowImgSelectPanel: false,
            isShowImgCropperPanel: false,

            ratio,

            imageUrl: null,
            cropperUrl: '',
            timer: 1,
        };
    },

    computed: {
        isEdit() {
            return this.imageUrl;
        },

        btnText() {
            return this.isEdit ? '修改' : '选择';
        },
    },

    watch: {
        initData(nextValue) {
            if (nextValue && nextValue.styleConfig && nextValue.styleConfig.backgroundImage) {
                this.imageUrl = nextValue.styleConfig.backgroundImage[this.platform] || '';
                this.$emit('confirm', this.imageUrl);
            }
        },
    },

    methods: {
        handleEdit() {
            // this.$message.error('系统维护'); return;
            this.isShowImgSelectPanel = true;
        },

        handleDelete() {
            const dialog = this.$confirm({
                title: '删除该背景？',
                content: '删除后将导致自定义背景设置失效',
                confirmText: '删除',
                status: 'warning',
                confirm: (e) => {
                    e.preventDefault();
                    dialog.$remove();

                    this.imageUrl = null;
                    this.$emit('confirm', this.imageUrl);
                },
            });
        },

        handleImgSelectConfirm(data) {
            this.cropperUrl = data.url;

            this.isShowImgSelectPanel = false;
            this.isShowImgCropperPanel = true;
            this.timer = new Date().getTime();
        },

        handleImgCropperConfirm(url) {
            this.isShowImgCropperPanel = false;

            this.imageUrl = url;
            this.$emit('confirm', this.imageUrl);
        },

        handleImgCropperCancel() {
            this.isShowImgCropperPanel = false;
        },
    },
};
</script>

<style lang="less">
@import '~@/common/common';

.webim-bg-select {
    margin-top: var(--spacing-extra-loose);

    &__btn,
    &__delete {
        display: inline-block;
    }

    &__btn {
        font-size: 14px;
        display: flex;
        align-items: center;
    }

    &__btnStyle {
        color: #4a70ff;
        cursor: pointer;
        margin-left: var(--spacing-base);
    }

    &__delete {
        margin-left: var(--spacing-base);
        color: #4a70ff;

        .v-icon {
            margin-right: 7px;
            float: left;
        }

        // &:hover {
        //     color: @mainBlue;
        // }
    }

    .section-item-label{
        padding: var(--padding-base) 0;
    }

    &__preview{
        width: 88px;
        height: 88px;
        display: flex;
        background: no-repeat center;
        background-size: cover;
        align-items: center;
        justify-content: center;
        border-radius: var(--radius-normal);
        border: 1px dashed var(--color-border-normal);
        cursor: pointer;

        &.no-border{
            border: 0;
        }

        .empty-text{
            color: var(--color-text-caption);
        }
    }
}
</style>
